import { ClickAwayListener, Popper } from '@mui/material';
import { CaretDown, CaretLeft, CaretRight } from '@phosphor-icons/react';
import { Dispatch, SetStateAction, useState } from 'react';

export const PaginatorVTwo = ({
  first,
  rows,
  totalRecords,
  currentPageNo,
  onPageChange,
  itemsPerPage,
  className = '',
  setItemsPerPageHandle,
  setRowSelected = () => 0,
}: {
  first: number;
  rows: number;
  totalRecords: number;
  currentPageNo: number;
  itemsPerPage: number;
  className: string;
  onPageChange: (page: number) => void;
  setItemsPerPageHandle: Dispatch<SetStateAction<number>>;
  setRowSelected: Dispatch<SetStateAction<number>>;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>();

  const handleClose = () => {
    setAnchorEl(null as unknown as HTMLButtonElement);
  };

  return (
    <div
      className={`flex items-center h-12 ${className}`}
      style={{
        zIndex: '1',
      }}
    >
      <span className="text-pv-text-secondary-text mr-2">Rows per page</span>
      <button
        className={`flex items-center gap-1 px-2 py-1 rounded-lg ${
          totalRecords <= 10
            ? `bg-white`
            : `hover:bg-pv-neutral-grey-100 text-pv-text-primary-text active:text-pv-neutral-grey-300 active:bg-white`
        }`}
        disabled={totalRecords <= 10}
        onClick={(e) => {
          setAnchorEl(
            (anchorEl ? null : e.currentTarget || e.target) as HTMLButtonElement
          );
        }}
      >
        <span className="w-5">{itemsPerPage}</span>
        <CaretDown
          weight="fill"
          style={{
            transition: 'all 0.3s ease',
          }}
          className={`text-pv-neutral-grey-600 ${
            anchorEl ? `transform rotate-180` : ``
          }`}
        />
      </button>
      <Popper
        open={anchorEl as unknown as boolean}
        anchorEl={anchorEl}
        placement="top"
      >
        <ClickAwayListener onClickAway={handleClose}>
          <div className="relative">
            <div
              className="bg-white border border-pv-primary-primary-100 w-10 rounded overflow-hidden"
              style={{
                boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.05)',
              }}
            >
              <div className="flex flex-col items-center">
                {[10, 50, 100].map((num, ind) => {
                  return (
                    <button
                      className="flex px-2 py-1 w-full justify-center hover:bg-pv-primary-primary-50 active:text-pv-text-disabled-text"
                      key={ind}
                      onClick={() => {
                        setItemsPerPageHandle(num);
                        localStorage.setItem(
                          'dashboard-rowCount',
                          num.toString()
                        );
                        onPageChange(1);
                        setAnchorEl(null as unknown as HTMLButtonElement);
                      }}
                    >
                      {num}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </ClickAwayListener>
      </Popper>
      <div className="flex items-center">
        <button
          className={`p-2 rounded-lg ${
            currentPageNo === 1
              ? `text-pv-primary-primary-300`
              : `text-pv-primary-primary-500 hover:bg-pv-primary-primary-100 active:text-pv-primary-primary-300 active:bg-pv-primary-primary-50`
          }`}
          disabled={currentPageNo === 1}
          onClick={() => {
            if (currentPageNo > 1) onPageChange(--currentPageNo);
            setRowSelected(0);
          }}
        >
          <CaretLeft />
        </button>
        <span className="mx-2">{`${first + 1}-${
          first + rows > totalRecords ? totalRecords : first + rows
        } of ${totalRecords}`}</span>
        <button
          className={`p-2 rounded-lg ${
            rows * currentPageNo >= totalRecords
              ? `text-pv-primary-primary-300`
              : `text-pv-primary-primary-500 hover:bg-pv-primary-primary-100 active:text-pv-primary-primary-300 active:bg-pv-primary-primary-50`
          }`}
          disabled={rows * currentPageNo >= totalRecords}
          onClick={() => {
            if (rows * currentPageNo < totalRecords)
              onPageChange(++currentPageNo);
            setRowSelected(0);
          }}
        >
          <CaretRight />
        </button>
      </div>
    </div>
  );
};
